<!--
	@name app-air-club-product
	@description Product tab view for the air club page
	@date 2020/02/21
	@license no license
	@copywrite Answers In Retirement Limited
-->

<template>
	<div :component="$options.name" class="pa-6">
		<common-structure-directory :items="products" :page-size="6" paginate :image-aspect-ratio="16/6">
			<template #title>
				Products
			</template>

			<template #detail>
				Operating in the later life market means considering a broad range of products and services to help meet your clients’ needs. The sections below highlight specialist solutions that may support your client conversations and advice process. Click on each section to explore the specific options available. For retirement lending, we operate a whole-of-market policy. Please use the "Source" link on the left to source a lifetime mortgage or retirement mortgage.
			</template>
		</common-structure-directory>
	</div>
</template>

<script>
	import { mapActions, mapGetters } from 'vuex';
	import CommonStructureDirectory from '@/component/common/structure/directory';

	export default {
		name: 'app-air-club-product',

		components: { CommonStructureDirectory },

		computed: {
			...mapGetters('AppMatterType', ['mappedMatterTypeList']),

			products() {
				const order = ['lifetime_mortgage', 'conveyancing', 'will', 'power_of_attorney', 'care_plans'];
				return this.mappedMatterTypeList
					?.filter((item) => item.nameUnique === 'lifetime_mortgage' || (item.data?.is_product === true && item.data?.hidden === false))
					.map((item) =>({
						...( item.nameUnique === 'lifetime_mortgage' ? { ...item, title: 'Mortgages', items: item.items.filter((provider) => provider.clubProvider) } : item ),
					    image: item.image?.replace('.jpg', '_new.jpg')
					})
					)
					.sort((a, b) => {
						const ai = order.indexOf(a.nameUnique);
						const bi = order.indexOf(b.nameUnique);
						const aPos = ai === -1 ? order.length : ai;
						const bPos = bi === -1 ? order.length : bi;
						return aPos - bPos;
					});
			}
		},

		created() {
			this.loadMatterTypeList({ with: 'organisation', order: { property: 'position' } });
		},

		methods: {
			...mapActions('AppMatterType', ['loadMatterTypeList'])
		}
	};
</script>

<style scoped lang="scss"></style>
